import { app } from '../app'
import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { errorMixin } from '../mixins/error-mixin'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VFormAddToCart from '../components/VFormAddToCart.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// @ts-ignore
import GLightbox from 'glightbox'

createApp({
  components: {
    VFormAddToCart
  },
  extends: app,
  mixins: [errorMixin],
  mounted () {
    this.$nextTick(() => {
      GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true
      })
    })
  }
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
